<div #dialog *ngIf="flowIndicator === 'BUY'">
  <ng-container *ngIf="(loaded$ | async) || modalIsOpen; else loading">
    <div class="cx-modal-container">
      <div class="cx-modal-content">
        <div class="cx-dialog-header modal-header">
          <div class="cx-dialog-title fav-modal-title">
            {{ 'myFavourites.itemShopngAdded' | cxTranslate }}
          </div>
          <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="dismissModal('Cross click')"
          >
            <span aria-hidden="true">
              <em class="material-icons">close</em>
            </span>
          </button>
        </div>
        <div class="cx-dialog-body modal-body products-to-buy-modal">
          <div class="cx-dialog-row">
            <div class="col-md-6 popup-content-1">
              <div
                *ngIf="productsEligible?.length > 0"
                class="row fav-modal-content-1"
              >
                {{ 'myFavourites.selectedItemsCart' | cxTranslate }}

                <div
                  *ngIf="productsNotEligible?.length > 0"
                  class="fav-modal-content-2"
                >
                  <em class="material-icons obsolete-prdct-warning">warning</em>
                  {{ 'myFavourites.obsoleteAdded' | cxTranslate }}
                </div>
              </div>
            </div>

            <div class="popup-content-2"></div>

            <div class="cx-dialog-actions popup-content-3">
              <div class="cx-dialog-buttons">
                <button
                  class="vs-primary-btn"
                  autofocus
                  (click)="dismissModal('View Cart click')"
                >
                  {{ 'myFavourites.contShop' | cxTranslate }}
                </button>
                <button
                  class="vs-tertiary-btn"
                  [routerLink]="{ cxRoute: 'cart' } | cxUrl"
                  autofocus
                >
                  {{ 'myFavourites.viewShoppingCart' | cxTranslate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #loading>
    <div class="cx-modal-container">
      <div class="cx-modal-content">
        <div class="cx-dialog-header modal-header">
          <div class="cx-dialog-title modal-title">
            {{ 'addCart.updatingCart' | cxTranslate }}
          </div>
          <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="dismissModal('Cross click')"
          >
            <span aria-hidden="true">
              <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
            </span>
          </button>
        </div>
        <!-- Modal Body -->
        <div class="cx-dialog-body modal-body">
          <div class="cx-dialog-row">
            <div class="col-sm-12"><cx-spinner></cx-spinner></div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>

<div *ngIf="flowIndicator === 'QUOTE'">
  <ng-container>
    <div class="cx-modal-container">
      <div class="cx-modal-content">
        <div class="cx-dialog-header modal-header">
          <div class="cx-dialog-title modal-title">
            {{ 'myFavourites.itemAdded' | cxTranslate }}
          </div>
          <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="dismissModal('Cross click')"
          >
            <span aria-hidden="true" class="show">
              <em class="material-icons">close</em>
            </span>
          </button>
        </div>
        <div class="cx-dialog-body modal-body products-to-quote-modal">
          <div class="cx-dialog-row">
            <div class="col-md-6 popup-content-1">
              <div
                *ngIf="productsEligible?.length > 0"
                class="row fav-modal-content-1"
              >
                {{ 'myFavourites.selectedItems' | cxTranslate }}
              </div>
            </div>

            <div class="popup-content-2"></div>
            <div class="cx-dialog-actions popup-content-3">
              <div class="cx-dialog-buttons">
                <button
                  class="vs-primary-btn"
                  autofocus
                  (click)="dismissModal('Continue Shopping')"
                >
                  {{ 'myFavourites.continueShoppingBtn' | cxTranslate }}
                </button>
                <button
                  class="vs-tertiary-btn"
                  autofocus
                  routerLink="/quote/cart"
                >
                  {{ 'myFavourites.quoteCartBtn' | cxTranslate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
